import React from 'react'
import { BrowserRouter,Routes,Route } from 'react-router-dom'
import HeroPage from './Components/HeroPage'
import AboutUs from './pages/AboutUs'
import ServiceDetails from './pages/ServiceDetailsComponent/ServiceDetails'
import TeamDetails from './pages/TeamDetailsComponent/TeamDetails'
import ContactUs from './pages/ContactUsComponent/ContactUs'
const App = () => {
  return (
    <>
     <BrowserRouter>
     <Routes>
      <Route path='' element={<HeroPage/>}/>
      <Route path='/about' element={<AboutUs/>}/>
      <Route path='/services' element={<ServiceDetails/>}/>
      <Route path='/team' element={<TeamDetails/>}/>
      <Route path='/contact' element={<ContactUs/>}/>

     </Routes>
     </BrowserRouter>
    </>
  )
}

export default App